import React, { Component } from 'react';
import OrderDetailList from './OrderDetailList';
import OrderOutgoingShipmentSection from './OrderOutgoingShipmentSection';
import AuditReportBuilder from './AuditReportBuilder';
import { Link } from 'react-router-dom';
import { ORDERS } from '../../routes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as ordersActions from '../../actions/orderActions';
import { getOrder } from '../../reducers/index';
import Loading from '../Loading';

class OrderDetailPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = { isMarkingShipped: false, isSavingAuditReport: false };
    this.orderId = props.match.params.id;
    this.saveAuditReport = this.saveAuditReport.bind(this);
    this.markShipped = this.markShipped.bind(this);
  }

  componentDidMount() {
    this.props.listenToOrder(this.orderId);
  }

  componentWillUnmount() {
    this.props.silenceOrder(this.orderId);
  }

  saveAuditReport(auditReport) {
    if (!this.state.isSavingAuditReport) {
      this.setState({ isSavingAuditReport: true });
      this.props
        .saveAuditReport(this.orderId, auditReport)
        .then(() => this.setState({ isSavingAuditReport: false }));
    }
  }

  markShipped(event) {
    event.preventDefault();
    if (!this.state.isMarkingShipped) {
      this.setState({ isMarkingShipped: true });
      this.props
        .markShipped(this.orderId)
        .then(() => this.setState({ isMarkingShipped: false }));
    }
  }

  readyToShip() {
    return (
      ['shipped', 'archived'].indexOf(this.props.order.status) === -1 &&
      this.props.order.outgoingLabelUrl
    );
  }

  render() {
    if (!this.props.order.id) {
      return <Loading />;
    }
    return (
      <div>
        <h1 className="display-4">Order: {this.props.order.id}</h1>
        <p className="mb-5">
          <Link to={ORDERS}>&laquo; Back to Orders</Link>
        </p>
        <OrderDetailList order={this.props.order} />
        {!this.props.order.auditReport && (
          <AuditReportBuilder
            isSaving={this.state.isSavingAuditReport}
            saveAuditReport={this.saveAuditReport}
          />
        )}
        {this.readyToShip() && (
          <OrderOutgoingShipmentSection
            order={this.props.order}
            markShipped={this.markShipped}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    order: getOrder(state, ownProps.match.params.id) || {},
    ...ownProps
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ordersActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailPage);



// WEBPACK FOOTER //
// ./src/components/orders/OrderDetailPage.js